module.exports = "<div class=\"login-info\">\n  <span *ngIf=\"user?.picture\"><a (click)=\"toggleShortcut()\">\n      <img [src]=\"image\" alt=\"me\" class=\"online\" (error)=\"onError()\" />\n      <span >{{userName}}</span> <i class=\"fa fa-angle-down\"></i>\n  </a>\n  </span>\n</div>\n<!-- -{{tk}} -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = ./src/app/shared/user/login-info/login-info.component.html
// module chunks = main